/**
 * @author xyguo
 * @description 新开业邮件通知
 * @Date 2021/3/11
 */
import React from 'react';
import { connect } from 'dva';
import { templateConfig, reduxTemplateCofig } from './config'

import { framework_tool, component_tool, utils_tool } from '@/tool'
let { WizContainer, WizReduxTemplate } = framework_tool;
let { WizSpin, WizButton, WizInput, WizRow, WizCol, WizTabs, WizAlert, WizModal, WizForm, WizCard, WizSearchBar, WizDataTable, WizBrowserExport } = component_tool
let { Session } = utils_tool
import moment from "moment";

const getParamRecord = (history) => {
  let record = {}
  if (history.location && history.location.pathname === "/requirementNotice/requirementNoticeList/requirementNoticeRecordList") {
    if (history.location.record) {
      record = history.location.record
      Session.set('requirementNoticeRecord', record);
    } else {
      record = Session.get('requirementNoticeRecord') || {}
    }
  }
  return record
}

const formatterMinute = (val) => {
  return val ? moment(val).format('YYYY-MM-DD HH:mm') : '';
}

class RequirementNoticeRecordList extends WizContainer {

  componentName = 'RequirementNoticeRecordList';

  constructor(props) {
    super(props);
    let { history } = this.props
    let initialValue = getParamRecord(history)
    this.state = {
    }
    this.initialValue = initialValue
  }

  _handleCMD(nextProps, nextState, key) {
    let o = nextProps[key]
    if (o['success']) {
      wizNotice.success(o['msg'])
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _handleFile(nextProps, nextState, key) {
    let o = nextProps[key]
    let columnDefs = [
      {
        headerName: '',
        width: 30,
        field: 'rowIndex',
        hidden: true,
        suppressMovable: true,
        cellStyle: {
          textAlign: 'center',
          padding: '5px 0',
          color: '#595959',
          backgroundColor: '#f0f0f0',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: '500',
          boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
        },
      },
      {
        headerName: '通知人',
        field: 'notifierStr',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '通知时间',
        field: 'noticeTime',
        width: 35,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '通知类型',
        field: 'noticeTypeStr',
        width: 60,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
    ]
    if (o['success']) {
      let data = o['data']
      let record = Session.get('requirementNoticeRecord');
      let title = record ? '省/自治区/直辖市: ' + record['provincial']
        + '\n' + '管理员: ' + record['requirementManagerStr']
        + '\n' + '是否为新能源店: ' + record['isNewEnergyStr']
        + '\n' + '是否有效: ' + record['stateStr'] : '';
      data && data.forEach(e => {
        e['noticeTime'] = formatterMinute(e['noticeTime']);
      })
      WizBrowserExport({
        title: title,
        sheetName: '新开业邮件通知记录',
        columns: columnDefs.filter((_, index) => index),
        rows: data,
        filename: '新开业邮件通知记录.xlsx',
        titleParams: {
          alignment: { vertical: 'bottom', horizontal: 'left', wrapText: true },
          style: {
            alignment: { vertical: "bottom", horizontal: "left", wrapText: true },
          },
          font: {},
        },
        titleRow: {
          height: 65
        }
      })
      return true
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _showTitle(record) {
    let content = <WizCard title={'邮件通知详情'} bodyStyle={{ paddingLeft: 20, paddingBottom: 25, paddingTop: 25 }}>
      <WizRow>
        <WizCol span={8} offset={2}>
          省/自治区/直辖市: {record.provincial}
        </WizCol>
        <WizCol span={7}>
          管理员: {record.requirementManagerStr}
        </WizCol>
        <WizCol span={7}>
          是否为新能源店: {record.isNewEnergyStr}
        </WizCol>
      </WizRow>
      <WizRow style={{ marginTop: 20 }}>
        <WizCol span={8} offset={2}>
          是否有效: {record.stateStr}
        </WizCol>
        <WizCol span={6}>
        </WizCol>
        <WizCol span={8}>
        </WizCol>
      </WizRow>

    </WizCard>
    return content;
  }

  _render() {
    let _reduxTemplateCofig = reduxTemplateCofig({
      noticeId: this.initialValue.id,
      templateConfig,
      apiDataFormat: {
        export: this._handleFile,
      },
    })
    return <>{this._showTitle(this.initialValue)}<WizCard title={'邮件记录'}>
      <WizReduxTemplate {..._reduxTemplateCofig} />
    </WizCard>
    </>
  }
}

const mapStateToProps = (state, ownProps) => {
  return {}
};

export default connect(mapStateToProps)(RequirementNoticeRecordList);
